import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router';

// Translations
import translate from '../Translate.js';

// Helpers
import { confirm, toggleDrawer } from '../../helpers/helpers.js'

// Dependencies
import moment from 'moment';
import Delayed from 'react-delayed';

// Components
import * as icons from '../Icons/Icons';
import Toolbar from '../Common/Toolbar';
import LoadMore from '../Common/LoadMore';
import Drawer from '../Drawer/Drawer';

const BlackoutDates = observer(class BlackoutDates extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.handleEdit = this.handleEdit.bind(this);
    this.deleteDates = this.deleteDates.bind(this);

    // Set the initial state
    this.state = {
      drawerOpen: false,
      drawerContent: null,
      selectedRows: []
    }
  }

  componentWillMount() {
    this.listBlackoutDates();
  }

  componentDidMount() {
    const { SessionStore } = this.props.store;
    const { pathname } = this.props.routing.location;

    if(pathname.indexOf('edit') > -1 || pathname.indexOf('add') > -1) {
      SessionStore.loading = false;
      toggleDrawer(null, this, 'EditBlackoutDate');
    }

    if(pathname.indexOf('edit') > -1) {
      let blackoutDateSid = pathname.substr(pathname.lastIndexOf('/') + 1);

      this.setState({
        blackoutDateSid
      });
    }
  }

  listBlackoutDates() {
    const { BlackoutStore } = this.props.store;

    const query = {
      limit: 25
    }

    BlackoutStore.listBlackoutDates(query);
  }

  handleEdit(e, blackoutDateSid) {
    e.preventDefault();

    // Update url
    let path = e.target.href.replace(/^(?:\/\/|[^\/]+)*\//, '').replace('#', '');

    if(this.props.routing.location.pathname !== path) {
      this.props.routing.push(path);
    }

    this.setState({
      drawerContent: 'EditBlackoutDate',
      blackoutDateSid
    });
  }

  handleSelect(e, sid) {
    let selectedRows = [...this.state.selectedRows];
    let rowIndex = -1;

    if(e.target.checked) {
      selectedRows.push(sid);
    } else {
      rowIndex = selectedRows.indexOf(sid);
      selectedRows.splice(rowIndex, 1);
    }

    this.setState({
      selectedRows
    });
  }

  deleteDates() {
    const { translation } = this.props;
    const { BlackoutStore } = this.props.store;

    let msg = {
      heading: `${translation.delete_confirm.heading_singular}`,
      body: translation.delete_confirm.body_singular,
      button: translation.delete_confirm.button
    }

    if(this.state.selectedRows.length > 1) {
      msg.heading = translation.delete_confirm.heading_plural.replace('%count%', this.state.selectedRows.length);
      msg.body = translation.delete_confirm.body_plural;
    }

    const callback = () => {
      this.listBlackoutDates();

      this.setState({
        selectedRows: []
      });
    };

    // Loop through all the selected blackout dates
    // and send delete API request
    const _this = this;

    confirm(
      msg,
      () => {
        for(let i = 0; i < _this.state.selectedRows.length; i++) {
          BlackoutStore.deleteBlackoutDate(
            _this.state.selectedRows[i],
            callback
          )
        }
      }
    );
  }

  renderResults() {
    const { translation } = this.props;
    const { BlackoutStore, SessionStore } = this.props.store;
    const { blackoutDates } = BlackoutStore;
    const { userTimezone } = SessionStore;

    if(blackoutDates.length > 0) {
      return (
        <table>
          <thead>
            <tr>
              <th
                id="heading-select"
                scope="col"
              >
                <span className="meta">Select</span>
              </th>
              <th
                id="heading-edit"
                className="subtitle"
                scope="col"
              >
                {translation.edit}
              </th>
              <th
                id="heading-start"
                className="subtitle"
                scope="col"
              >
                {translation.start_date}
              </th>
              <th
                id="heading-end"
                className="subtitle"
                scope="col"
              >
                {translation.end_date}
              </th>
            </tr>
          </thead>
          <tbody>
            {blackoutDates.map(
              (blackoutDate, i) =>
              <tr key={i}>
                <td
                  className="check-col"
                  aria-labelledby="heading-select"
                >
                  <input
                    id={`select-${blackoutDate.sid}`}
                    className="checkbox-input"
                    type="checkbox"
                    onChange={(e) => this.handleSelect(e, blackoutDate.sid)}
                    checked={this.state.selectedRows.indexOf(blackoutDate.sid) > -1}
                  />

                  <label
                    className="checkbox-label checkbox-label--solo"
                    htmlFor={`select-${blackoutDate.sid}`}
                  >
                    <span className="meta">Select {blackoutDate.sid}</span>
                  </label>
                </td>
                <td aria-labelledby="heading-edit">
                  <Link
                    to={`/blackout-dates/edit/${blackoutDate.sid}`}
                    onClick={(e) => {this.handleEdit(e, blackoutDate.sid)}}
                    title={`Edit ${blackoutDate.title}`}
                  >
                    {translation.edit}
                  </Link>
                </td>
                <td aria-labelledby="heading-start">
                  {moment.utc(blackoutDate.startDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')}
                </td>
                <td aria-labelledby="heading-end">
                  {moment.utc(blackoutDate.endDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )
    } else if(blackoutDates.length === 0 && !SessionStore.loading) {
      return (
        <span className="no-results">{translation.no_results}</span>
      )
    }

    return null;
  }

  render() {
    const { translation } = this.props;
    const { BlackoutStore } = this.props.store;
    const { blackoutDates, blackoutDatesNext } = BlackoutStore;

    return (
      <main tabIndex="0" id="main-content" className="page">
        <header className="page__header">
          <div className="wrap">
            <h1 className="page__title">{translation.page_title}</h1>

            <Link
              className="btn--outline"
              to="blackout-dates/add"
            >
              <icons.iconPlus />
              {translation.add}
            </Link>
          </div>
        </header>

        <div className="wrap">
          {this.renderResults()}
        </div>

        {blackoutDatesNext &&
          <LoadMore
            url={blackoutDatesNext}
            group={blackoutDates}
            text="Load more results"
            {...this.props}
          />
        }

        <Delayed
          mounted={this.state.selectedRows.length > 0}
          unmountAfter={250}
        >
          <Toolbar
            selectedRows={this.state.selectedRows}
            deleteText={translation.delete}
            deleteFunction={this.deleteDates}
            {...this.props}
          />
        </Delayed>

        <Drawer
          content={this.state.drawerContent}
          isOpen={this.state.drawerOpen}
          parent={this}
          {...this.props}
          blackoutDateSid={this.state.blackoutDateSid}
        />
      </main>
    )
  }
})

export default translate('BlackoutDates')(BlackoutDates);



// WEBPACK FOOTER //
// ./src/app/components/BlackoutDates/BlackoutDates.js